import React from 'react'
import TopNav from '../components/TopNav'
import Footer from '../components/Footer'
import './JuneteenthPage.css'

const JuneteenthPage: React.FC = () => {
    return (
        <>
            <TopNav />
            <div className="juneteenth-page">
                {/* Cover Section */}
                <section className="cover">
                    <img className="cover-img"
                        src="img/events/timekeepers/timekeepers.png"
                        alt="Timekeepers of Timbuktu Cover" />
                    <p className="cover-caption">Juneteenth Steampunk Ball 2026 · Archetype Mood Boards</p>
                    <p className="cover-sub">"Ancient Mali · Steampunk · Victorian · Wakanda"</p>
                </section>

                {/* <!-- ══ ARC I: GUARDIANS ══ --> */}
                <section className="arc arc-1">
                    <div className="mudcloth"></div>
                    <div className="gear-bg gear-a"></div>
                    <div className="gear-bg gear-b"></div>

                    <div className="arc-header">
                        <div className="arc-header-info">
                            <p className="arc-eyebrow">Stewards of the Eternal Empire</p>
                            <div className="arc-num-row">
                                <span className="arc-badge">I</span>
                                <h2 className="arc-title">Guardians<br />of Time</h2>
                            </div>
                            <p className="arc-subtitle">They walk as living clocks — warriors whose breath keeps the timelines aligned.</p>
                            <p className="arc-story">Shield-bearers of a Mali Empire untouched by the fall of kingdoms. Each Guardian is bound
                                to a sacred charge: defend the empire's ancient memory, recover stolen knowledge, and ensure no force distorts
                                the past.</p>
                            <div className="arc-tags">
                                <span className="tag">Armor</span>
                                <span className="tag">Cloaks</span>
                                <span className="tag">Chronoblades</span>
                                <span className="tag">Celestial Masks</span>
                                <span className="tag">N'ko Engravings</span>
                                <span className="tag">Brass-Plated</span>
                            </div>
                            <div className="think-row">
                                <p className="think-label">Think…</p>
                                <div className="think-tags">
                                    <span className="think-tag">Woman King</span>
                                    <span className="think-tag">Dora Milaje</span>
                                    <span className="think-tag">Wakandan Border Tribe</span>
                                </div>
                            </div>
                        </div>
                        <div className="arc-header-img">
                            <img
                                src="img/events/timekeepers/guardiansoftime.png"
                                alt="Guardians of Time info" />
                        </div>
                    </div>

                    <div className="char-grid">
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/sandwarden.png"
                                alt="The Sand Warden" />
                            <div className="char-card-label">
                                <p className="char-name">The Sand Warden</p>
                                <p className="char-role">Guardian of the Timestorm</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/riftrunner.png"
                                alt="The Rift Runner" />
                            <div className="char-card-label">
                                <p className="char-name">The Rift Runner</p>
                                <p className="char-role">Temporal Warrior</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/bronzesentinel.png"
                                alt="The Bronze Sentinel" />
                            <div className="char-card-label">
                                <p className="char-name">The Bronze Sentinel</p>
                                <p className="char-role">Immovable Guardian of the Sahel</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <!-- ══ ARC II: SCHOLARS ══ --> */}
                <section className="arc arc-2">
                    <div className="mudcloth"></div>
                    <div className="gear-bg gear-a"></div>
                    <div className="gear-bg gear-b"></div>

                    <div className="arc-header">
                        <div className="arc-header-img">
                            <img
                                src="img/events/timekeepers/legendaryscholars.png"
                                alt="Legendary Scholars info" />
                        </div>
                        <div className="arc-header-info">
                            <p className="arc-eyebrow">Visionaries of the Infinite Library</p>
                            <div className="arc-num-row">
                                <span className="arc-badge">II</span>
                                <h2 className="arc-title">Legendary<br />Scholars</h2>
                            </div>
                            <p className="arc-subtitle">They push humanity forward by reading fate encoded in constellations and ancient
                                spirals.</p>
                            <p className="arc-story">Beneath Timbuktu's gleaming towers lies a vast living archive. These sages merge mysticism,
                                mathematics, and star-born engineering — not mere keepers of books, but architects of tomorrow.</p>
                            <div className="arc-tags">
                                <span className="tag">Scholarly Robes</span>
                                <span className="tag">Cloaks</span>
                                <span className="tag">Mechanical Scroll Cases</span>
                                <span className="tag">Circuit-Bead Jewelry</span>
                                <span className="tag">Copper Glyphs</span>
                                <span className="tag">Ancient Amulets</span>
                            </div>
                            <div className="think-row">
                                <p className="think-label">Think…</p>
                                <div className="think-tags">
                                    <span className="think-tag">Ancient Librarian</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="char-grid">
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/theinkdiviner.png"
                                alt="The Ink Diviner" />
                            <div className="char-card-label">
                                <p className="char-name">The Ink Diviner</p>
                                <p className="char-role">Knowledge from the Stars</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/archivistofechoes.png"
                                alt="Archivist of Echoes" />
                            <div className="char-card-label">
                                <p className="char-name">Archivist of Echoes</p>
                                <p className="char-role">Guardian of the Ancestral Memory</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/thestargazerengineer.png"
                                alt="The Stargazer Engineer" />
                            <div className="char-card-label">
                                <p className="char-name">The Stargazer Engineer</p>
                                <p className="char-role">Scholar of Timbuktu & the Celestial Arts</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/thelibrarian.png"
                                alt="The Librarian" />
                            <div className="char-card-label">
                                <p className="char-name">The Librarian</p>
                                <p className="char-role">Keeper of the Living Word</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/thearchivist.png"
                                alt="The Archivist" />
                            <div className="char-card-label">
                                <p className="char-name">The Archivist</p>
                                <p className="char-role">Cartographer of Lost Time</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <!-- ══ ARC III: ROYAL COURT ══ --> */}
                <section className="arc arc-3">
                    <div className="mudcloth"></div>
                    <div className="gear-bg gear-a"></div>
                    <div className="gear-bg gear-b"></div>

                    <div className="arc-header">
                        <div className="arc-header-info">
                            <p className="arc-eyebrow">Masters of Influence and Hidden Eyes</p>
                            <div className="arc-num-row">
                                <span className="arc-badge">III</span>
                                <h2 className="arc-title">The Royal<br />Court</h2>
                            </div>
                            <p className="arc-subtitle">Elegance woven with espionage — behind every toast lies an encrypted message.</p>
                            <p className="arc-story">The rulers and nobles of the eternal Mali Empire wield power with velvet precision. Their
                                salons glitter with beauty and danger; vast spy networks track stolen African artifacts across continents and
                                centuries.</p>
                            <div className="arc-tags">
                                <span className="tag">Victorian </span>
                                <span className="tag">Steampunk Ball</span>
                                <span className="tag">Elegant Masks</span>
                                <span className="tag">Gloves</span>
                                <span className="tag">Decorative Fans</span>
                                <span className="tag">African Royalty</span>
                                <span className="tag">Gems & Jewels</span>
                                <span className="tag">Symbolic Elements</span>
                            </div>
                            <div className="think-row">
                                <p className="think-label">Think…</p>
                                <div className="think-tags">
                                    <span className="think-tag">Bridgerton meets Ancient Africa</span>
                                </div>
                            </div>
                        </div>
                        <div className="arc-header-img">
                            <img
                                src="img/events/timekeepers/theroyalcourt.png"
                                alt="Royal Court info" />
                        </div>
                    </div>

                    <div className="char-grid">
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/thewhisperingduchess.png"
                                alt="The Whispering Duchess" />
                            <div className="char-card-label">
                                <p className="char-name">The Whispering Duchess</p>
                                <p className="char-role">Noblewoman of the Sahelian Frontier</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/thewhisperingduke.png"
                                alt="The Whispering Duke" />
                            <div className="char-card-label">
                                <p className="char-name">The Whispering Duke</p>
                                <p className="char-role">Nobleman of the Sahelian Frontier · Keeper of Secrets</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/theprinceofmirrors.png"
                                alt="The Prince of Mirrors" />
                            <div className="char-card-label">
                                <p className="char-name">The Prince of Mirrors</p>
                                <p className="char-role">Master of Disguise · Shaper of Realities</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/thecourtspymaster.png"
                                alt="The Court Spymaster" />
                            <div className="char-card-label">
                                <p className="char-name">The Court Spymaster</p>
                                <p className="char-role">Seer of Secrets · Weaver of Shadows</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <!-- ══ ARC IV: ARCHAEOLOGISTS ══ --> */}
                <section className="arc arc-4">
                    <div className="mudcloth"></div>
                    <div className="gear-bg gear-a"></div>
                    <div className="gear-bg gear-b"></div>

                    <div className="arc-header">
                        <div className="arc-header-img">
                            <img
                                src="img/events/timekeepers/thearchaeologists.png"
                                alt="Archaeologists info" />
                        </div>
                        <div className="arc-header-info">
                            <p className="arc-eyebrow">Relentless Seekers of the Lost and Stolen</p>
                            <div className="arc-num-row">
                                <span className="arc-badge">IV</span>
                                <h2 className="arc-title">The<br />Archaeologists</h2>
                            </div>
                            <p className="arc-subtitle">Driven by wonder, hunger, and fierce devotion — carrying the quest into the world's
                                shadows.</p>
                            <p className="arc-story">These adventurers travel the desert, the deep sea, and forbidden galleries of European
                                collectors. Some seek honor, some wealth, some redemption — all are drawn to recover every stolen artifact
                                that once belonged to the empire's embrace.</p>
                            <div className="arc-tags">
                                <span className="tag">Leather Harness</span>
                                <span className="tag">Leather Goods</span>
                                <span className="tag">Brass Gadgets</span>
                                <span className="tag">Excavation Tool Belt</span>
                                <span className="tag">Maps</span>
                                <span className="tag">Desert Goggles</span>
                                <span className="tag">Gauntlets</span>
                                <span className="tag">Artifacts</span>
                            </div>
                            <div className="think-row">
                                <p className="think-label">Think…</p>
                                <div className="think-tags">
                                    <span className="think-tag">An African Indiana Jones</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="char-grid">
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/thedesertfox.png"
                                alt="The Desert Fox" />
                            <div className="char-card-label">
                                <p className="char-name">The Desert Fox</p>
                                <p className="char-role">Seeker of Forgotten Lore · Archaeological Adventurer</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/thestormbreakerdiver.png"
                                alt="The Stormbreaker Diver" />
                            <div className="char-card-label">
                                <p className="char-name">The Stormbreaker Diver</p>
                                <p className="char-role">Explorer of Flooded Cities & the Deep Abyss</p>
                            </div>
                        </div>
                        <div className="char-card">
                            <img
                                src="img/events/timekeepers/theroguecurator.png"
                                alt="The Rogue Curator" />
                            <div className="char-card-label">
                                <p className="char-name">The Rogue Curator</p>
                                <p className="char-role">Operative of the Sahelian Heritage League</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    )
}

export default JuneteenthPage
